import ZkDictionaryTransform from './src/main'
ZkDictionaryTransform.install = function (Vue) {
  Vue.component(ZkDictionaryTransform.name, ZkDictionaryTransform)
}
export default ZkDictionaryTransform



// WEBPACK FOOTER //
// ./src/cdpBase/baseComponents/dictionaryTransform/index.js